import type { FaireProductEntity } from "../../entity_types/product";

export const p_dubf45d3e4: FaireProductEntity = {
  token: "p_dubf45d3e4",
  type: "product",
  name: "Zen Garden Crystal Lamp - Sacred Space Meditation Decor",
  brandToken: "b_9aggj4kudk",
  brandName: "Earth's Gems BTQ",
  imageUrl:
    "https://cdn.faire.com/fastly/bffeae438b3e0e5300cddde554c470128b6b75427f90dabdf7a5231189b4f6b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a218798e54390dd478b96fafd4ed5e28b4ac0e8c908be9b74a695db4cda3f76.jpeg",
    "https://cdn.faire.com/fastly/368a643eaba79d21d839332a709bb803da83ccb221f2653389d3b5c8ae8ea257.jpeg",
    "https://cdn.faire.com/fastly/45d6e6ffd29f35e8d65495c0121ceec8be29fd86c828edbf673bdc6b49ac5225.jpeg",
    "https://cdn.faire.com/fastly/9445c4ea46baab05eaaa1c10495f68eac59a7ec5eff848e06e46f07987b8f6d5.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "\n\nThis gently glowing round LED lamp, enriched with real gemstones and greenery, is designed to support your relaxation and meditation practices. The Zen Garden Crystal Night Light offers soothing illumination that fosters a calm and balanced atmosphere, helping you create a mindful and serene home environment. Its soft, warm light is ideal for unwinding and cultivating peace in any room.\n\n\n",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:51.605Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
